export enum DatiqButtonTypes {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Danger = 'danger',
    DangerGhost = 'danger_ghost'
}

export enum DatiqButtonSizes {
    Standard = 'standard',
    Condensed = 'condensed'
}
